import { render } from "./CreateOrJoin.vue?vue&type=template&id=789a63e0&scoped=true"
import script from "./CreateOrJoin.vue?vue&type=script&lang=js"
export * from "./CreateOrJoin.vue?vue&type=script&lang=js"

import "./CreateOrJoin.vue?vue&type=style&index=0&id=789a63e0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789a63e0"]])

export default __exports__